import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    inject,
    input,
} from '@angular/core';
import { map, Observable } from 'rxjs';
import { SubSink } from 'subsink';
import { QueryObserverResult } from '@ngneat/query';
import { SvgIconComponent } from 'angular-svg-icon';
import { CurrentPrevious } from '../../models/current-previous';

@Component({
    selector: 'app-trend',
    templateUrl: './trend.component.html',
    styleUrls: ['./trend.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SvgIconComponent],
})
export class TrendComponent implements OnInit, OnDestroy {
    private cdr = inject(ChangeDetectorRef);

    readonly percentChange = input<number>();
    readonly percentChangeQuery =
        input<Observable<QueryObserverResult<CurrentPrevious, Error>>>();

    readonly inverted = input<boolean>(false);
    readonly is7Days = input<boolean>(false);
    readonly isDwellComponet = input<boolean>(false);
    result: number = 0;

    private sub = new SubSink();

    ngOnInit() {
        const percentChangeQuery = this.percentChangeQuery();
        if (percentChangeQuery) {
            this.sub.sink = percentChangeQuery
                .pipe(
                    map((a) => Object.assign(new CurrentPrevious(), a.data)),
                    map((a) => a.percentChange ?? 0),
                )
                .subscribe((x) => {
                    this.result = x ?? 0;
                    this.cdr.markForCheck();
                });
        } else {
            this.result = this.percentChange() ?? 0;
        }
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    formatPercent(percent: number) {
        return Math.abs(percent).toFixed(0);
    }
    get getDay() {
        if (this.is7Days()) {
            return 7;
        } else {
            return 30;
        }
    }
}
